import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const r = i((o, a) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: a,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.66 3.007 9.48 4.336C8.905 4.98 9.363 6 10.226 6h11.546c.863 0 1.32-1.02.748-1.664l-1.181-1.33A3 3 0 0 0 19.097 2h-6.194a3 3 0 0 0-2.242 1.007M0 25V11a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3m22-7a6 6 0 1 1-12 0 6 6 0 0 1 12 0M5 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4m15 3a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "SelfiesIcon";
export {
  r as SelfiesIcon,
  r as default
};
//# sourceMappingURL=index.js.map
